<template>
  <div class="page-wrapper-table slect-list">
    <div class="page-wrapper-table-header" v-if="!filterInvoice">
      <el-select
        class="select-primary pagination-select"
        v-model="pagination.perPage"
        :placeholder="$t('COMMON.PER_PAGE')"
      >
        <el-option
          class="select-primary"
          v-for="item in pagination.perPageOptions"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>

      <base-input>
        <el-select
          :placeholder="$t('COMMON.STATUS')"
          name="status"
          v-model="selectedStatus"
        >
          <el-option value="" :label="$t(`COMMON.ALL`)" />
          <el-option
            v-for="(label, val) in statusesOption"
            v-bind:key="val"
            :value="val"
            :label="`${label ? $t('TRANSACTIONS_DPA.' + label) : ''}`"
          />
        </el-select>
      </base-input>

      <base-input
        v-model="query"
        type="search"
        prepend-icon="fas fa-search"
        :placeholder="$t('COMMON.SEARCH')"
        clearable
      />
    </div>
    <div class="page-wrapper-table-body">
      <div class="page-wrapper-table-body-inner">
        <el-table
          class="align-items-center table-flush selector"
          header-row-class-name="thead-light"
          :data="transactions"
          @sort-change="sortChange"
          ref="transactionTable"
          row-class-name="clickable-row"
          @row-click="toggleRowSelection"
          @selection-change="handleSelectionChange"
        >
          <div class="table-loading" slot="empty" v-if="loading">
            <img src="/img/loading.gif" />
          </div>
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column label="Code" min-width="220px" prop="code" />

          <el-table-column :label="null" prop="status" min-width="150">
            <template v-slot:header>
              <ArrowsUpDown />
            </template>
            <template v-slot="{ row }">
              <in-out-badge :type="row.transaction_type" />
            </template>
          </el-table-column>

          <!-- <el-table-column
            :label="$t('COMMON.DATE')"
            prop="date"
            sortable="date"
            min-width="220"
          >
            <template v-slot="{ row }">
              {{ row.date | moment("LLLL") }}
            </template>
          </el-table-column> -->

          <el-table-column
            :label="$t('COMMON.STATUS')"
            prop="status"
            min-width="220"
          >
            <template v-slot="{ row }">
              <status-badge :data="row" />
            </template>
          </el-table-column>

          <el-table-column
            :label="$t('COMMON.AMOUNT')"
            prop="amount"
            sortable="custom"
            min-width="150"
          >
            <template v-slot="{ row }">
              <amount-badge :type="row.transaction_type" :amount="row.amount" />
            </template>
          </el-table-column>

          <!--  <el-table-column
            :label="$t('COMMON.AMOUNT')"
            prop="amount"
            min-width="220"
          >
            <template v-slot="{ row }">
              {{ $formatCurrency(row.amount) }}
            </template>
          </el-table-column> -->

          <el-table-column
            :label="$t('SIGNATURES.CREATED_AT')"
            prop="created_at"
            sortable="custom"
            min-width="220"
          >
            <template v-slot="{ row }">
              {{ $timeZoneDateFormat(row.created_at) }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" min-width="120">
            <div slot-scope="{ row }" class="table-actions">
              <el-tooltip
                :content="$t('COMMON.VIEW')"
                placement="top"
                v-if="
                  $currentUserCan($permissions.PERM_VIEW_TRANSACTIONS_DPA)
                "
              >
                <a
                  type="text"
                  @click="viewTransaction(row)"
                  class="table-action"
                  data-toggle="tooltip"
                  style="cursor: pointer"
                >
                  <i class="fal fa-expand-alt"></i>
                </a>
              </el-tooltip>
              <el-tooltip
                :content="$t('COMMON.VALIDATE')"
                placement="top"
                v-if="row.status != 'COMPLETED'"
              >
                <a
                  type="text"
                  @click="validateTransaction(row)"
                  class="table-action"
                  data-toggle="tooltip"
                  style="cursor: pointer"
                >
                  <i class="fal fa-check"></i>
                </a>
              </el-tooltip>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="row">
      <div class="col-6" v-if="selectedRows.length">
        <el-divider />
        <h4 v-if="selectedRows?.length == 1">
          {{ $t("PAYMENTS.FOR_THE_SELECTED_TRANSACTION") }}
        </h4>
        <h4 v-else>
          {{
            $t("PAYMENTS.FOR_THE_SELECTED_TRANSACTIONS", {
              nb: selectedRows?.length,
            })
          }}
        </h4>
        <div
          v-if="selectedArePending || selectedAreHoldon"
          class="submit-wrapper"
        >
          <base-button
            v-if="selectedArePending || selectedAreHoldon"
            class="elite-button add mr-3"
            icon
            size="sm"
            :disabled="processing"
            @click="toggleOnHold"
          >
            <i class="fas fa-spinner fa-spin" v-if="processing"></i>
            <span v-else class="btn-inner--icon">
              <i class="far fa-plus-circle"></i>
            </span>
            <span class="btn-inner--text" v-if="selectedArePending">{{
              $t("PAYMENTS.PUT_ON_HOLD")
            }}</span>
            <span class="btn-inner--text" v-else>{{
              $t("PAYMENTS.PUT_ON_PENDING")
            }}</span>
          </base-button>
          <base-button
            v-if="selectedArePending"
            :loading="processing"
            :disabled="processing"
            class="btn btn-outline-success btn-success"
            icon
            size="sm"
            @click="sendPaymentsToDpa"
          >
            <span class="btn-inner--icon">
              <i class="fa fa-paper-plane"></i>
            </span>
            <span class="btn-inner--text">
              {{ $t("PAYMENTS.SEND_TO_DPA") }}
            </span>
          </base-button>
        </div>
        <p v-else class="card-category text-red">
          {{ $t("PAYMENTS.SELECT_SAME_STATUS_TO_SHOW_OPTIONS") }}
        </p>
      </div>
      <div
        slot="footer"
        :class="
          'page-wrapper-table-footer ' +
          (selectedRows.length ? 'col-6' : 'col-12')
        "
      >
        <p class="card-category">
          {{
            $t("COMMON.DISPLAY_FROM_X_TO_X_OF_X_ENTRIES", {
              from: total ? from + 1 : 0,
              to: to,
              of: total,
            })
          }}

          <span v-if="selectedRows.length">
            &nbsp; &nbsp;
            {{ $t("COMMON.X_LINES_SELECTED", { count: selectedRows.length }) }}
          </span>
        </p>
        <base-pagination
          class="pagination-no-border"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
  Divider,
} from "element-ui";
import "sweetalert2/dist/sweetalert2.css";
import { INVOICE_STATUS_SENT } from "@/constants/invoices";
import {
  STATUS_DRAFT,
  STATUS_PENDING,
  STATUS_HOLDON,
} from "@/constants/transactions";
import { BasePagination } from "@/components";
import StatusBadge from "../components/StatusBadge.vue";
import InOutBadge from "../components/atoms/InOutBadge.vue";
import AmountBadge from "../components/atoms/AmountBadge.vue";
import ArrowsUpDown from "../components/Icons/ArrowsUpDown.vue";
import { TRANSACTIONS_STATUS } from "@/constants/transactions";

export default {
  name: "transaction-list-table",

  components: {
    BasePagination,
    StatusBadge,
    [Tooltip.name]: Tooltip,
    [Divider.name]: Divider,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    InOutBadge,
    AmountBadge,
    ArrowsUpDown,
  },

  mixins: [],

  props: {
    filterOrganization: {
      type: String,
      default: null,
      description: "Organization id",
    },
    filterInvoice: {
      type: String,
      default: null,
      description: "Invoice id",
    },
    processing: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selectedArePending: false,
      selectedAreHoldon: false,
      selectedAmount: 0,
      query: null,
      selectedRows: [],
      sort: "-created_at",
      total: 0,
      pagination: {
        perPage: 20,
        currentPage: 1,
        perPageOptions: [20, 50, 100, 500],
      },
      transactions: [],
      INVOICE_STATUS_SENT: INVOICE_STATUS_SENT,
      loading: true,
      selectedOrganization: null,
      selectedLocation: null,
      selectedStatus: null,
      statusesOption: TRANSACTIONS_STATUS,
      STATUS_DRAFT: STATUS_DRAFT,
      STATUS_PENDING: STATUS_PENDING,
      STATUS_HOLDON: STATUS_HOLDON,
    };
  },

  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },

  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
    filterOrganization: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedOrganization: {
      handler: "getListDebounced",
      immediate: true,
    },
    filterInvoice: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedLocation: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedStatus: {
      handler: "getListDebounced",
      immediate: true,
    },
  },

  methods: {
    handleSelectionChange(selected) {
      this.selectedRows = selected; // Met à jour les lignes sélectionnées
      this.selectedArePending = selected.every(
        (transaction) => transaction.status === STATUS_PENDING
      );
      this.selectedAreHoldon = selected.every(
        (transaction) => transaction.status === STATUS_HOLDON
      );
    },
    updateSelection(selected) {
      this.selectedRows = selected;
      this.selectedArePending = selected.every(
        (transaction) => transaction.status === STATUS_PENDING
      );
      this.selectedAreHoldon = selected.every(
        (transaction) => transaction.status === STATUS_HOLDON
      );
    },

    toggleRowSelection(row) {
      this.$refs.transactionTable.toggleRowSelection(row);
    },

    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    async getList() {
      try {
        this.loading = true;
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...(this.query ? { code: this.query } : {}),
          },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: { ...params.filter, organization: this.filterOrganization },
          };
        }
        if (this.selectedOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.selectedOrganization,
            },
          };
        }

        if (this.selectedStatus) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              status: this.selectedStatus,
            },
          };
        }

        await this.$store.dispatch("transactionDpas/list", params);
        this.transactions = this.$store.getters["transactionDpas/list"];
        this.total = this.$store.getters["transactionDpas/listTotal"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    viewTransaction(transaction) {
      this.$emit("onViewTransaction", transaction);
    },

    toggleOnHold() {
      this.$emit("onToggleOnHold", this.selectedRows);
    },

    sendPaymentsToDpa() {
      this.$emit("onSendPaymentsToDpa", this.selectedRows);
    },

    validateTransaction(transaction) {
      this.$emit("onValidateTransaction", transaction);
    },

    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `-${prop}`;
      } else {
        this.sort = `${prop}`;
      }
      this.getList();
    },
  },
};
</script>
